import * as path from "path";
import { log } from "../../logging";
import { UserCanceled } from "../../util/CustomErrors";
import * as fs from "../../util/fs";
import getNormalizeFunc from "../../util/getNormalizeFunc";
import { truthy } from "../../util/util";
import { MERGED_PATH } from "./modMerging";
import renderModName from "./util/modName";
async function ensureWritable(api, modPath) {
    await fs.ensureDirWritableAsync(modPath, () => api
        .showDialog("question", "Access Denied", {
        text: "The mod folder for this game is not writable to your user account.\n" +
            "If you have admin rights on this system, Vortex can change the permissions " +
            "to allow it write access.",
    }, [{ label: "Cancel" }, { label: "Allow access" }])
        .then((result) => result.action === "Cancel"
        ? Promise.reject(new UserCanceled())
        : Promise.resolve()));
}
/**
 * activate a list of mod
 *
 * @export
 * @param {string} installationPath the path where mods are installed
 * @param {string} destinationPath the game mod path
 * @param {IMod[]} mods list of mods to activate (sorted from lowest to highest
 * priority)
 * @param {IDeploymentMethod} method the activator to use
 * @returns {Promise<void>}
 */
async function deployMods(api, gameId, installationPath, destinationPath, mods, method, lastActivation, typeId, skipFiles, subDir, progressCB) {
    if (!truthy(destinationPath)) {
        return Promise.resolve([]);
    }
    log("info", "deploying", {
        gameId,
        typeId,
        installationPath,
        destinationPath,
    });
    try {
        await ensureWritable(api, destinationPath);
        const normalize = await getNormalizeFunc(destinationPath);
        await method.prepare(destinationPath, true, lastActivation, normalize);
        for (let idx = 0; idx < mods.length; idx++) {
            const mod = mods[idx];
            if (progressCB !== undefined) {
                progressCB(renderModName(mod), Math.round((idx * 50) / mods.length));
            }
            const modPath = path.join(installationPath, mod.installationPath);
            if (mod.fileOverrides !== undefined) {
                mod.fileOverrides
                    .map((file) => {
                    const relPath = path.relative(destinationPath, file);
                    const relPathWithSource = path.join(mod.installationPath, relPath);
                    const normRelPathWithSource = normalize(relPathWithSource);
                    return normRelPathWithSource;
                })
                    .forEach((file) => skipFiles.add(file));
            }
            await method.activate(modPath, mod.installationPath, subDir(mod), skipFiles);
        }
        const mergePath = truthy(typeId)
            ? MERGED_PATH + "." + typeId
            : MERGED_PATH;
        await method.activate(path.join(installationPath, mergePath), mergePath, subDir(null), new Set());
    }
    catch (err) {
        if (method.cancel !== undefined) {
            method.cancel(gameId, destinationPath, installationPath);
        }
        throw err;
    }
    const cb = progressCB === undefined
        ? undefined
        : (files, total) => progressCB(`${files}/${total} files`, 50 + (files * 50) / total);
    return method.finalize(gameId, destinationPath, installationPath, cb);
}
export default deployMods;
